import { SprinklesElement } from "sprinkles-js";

/**
 * ConditionalInputsElement - Shows/hides target elements based on input checked state
 *
 * Usage:
 * <conditional-inputs>
 *   <input type="checkbox" data-conditional-inputs-toggle="email-field" />
 *   <input type="radio" data-conditional-inputs-toggle="email-field" />
 *   <div id="email-field" hidden>Content to show conditionally</div>
 * </conditional-inputs>
 */
export default class ConditionalInputsElement extends SprinklesElement {
  static tagName = "conditional-inputs";
  static events = { change: "handleChange" };

  afterConnected() {
    const toggles = this.querySelectorAll("[data-conditional-inputs-toggle]");
    this.targets = Array.from(toggles).reduce((acc, toggle) => {
      const selectors = toggle
        .getAttribute("data-conditional-inputs-toggle")
        .split(" ");

      selectors.filter(Boolean).forEach((selector) => {
        acc[selector] ||= {
          toggles: [],
          node: document.getElementById(selector),
        };
        acc[selector].toggles.push(toggle);
      });

      return acc;
    }, {});

    // Initialize visibility on connect
    this.#updateConditionalVisibility();
  }

  handleChange(event) {
    // Only handle changes from toggles
    if (event.target.hasAttribute("data-conditional-inputs-toggle")) {
      this.#updateConditionalVisibility();
    }
  }

  #updateConditionalVisibility() {
    // For each target, show if any of its toggles are checked
    Object.values(this.targets).forEach((target) => {
      if (!target.node) return;

      const shouldShow = target.toggles.some((t) => t.checked);
      target.node.hidden = !shouldShow;
    });
  }
}
